module.exports = __webpack_public_path__ + "static/media/checkmark-off-small.eb2eda3f.svg";